export default "__VITE_ASSET__LIJctVOL__"